'use client';
import { GoogleAnalytics, GoogleTagManager } from '@next/third-parties/google';
import { useEffect } from 'react';
import { ccStorage } from '../../utils/storages/local/CookieStorageClient';

interface GoogleTrackingProps {
  gaId?: string;
  gtmId?: string;
  consent?: boolean;
  needConsent?: boolean;
}

const GoogleTracking = ({
  gaId,
  gtmId,
  consent,
  needConsent,
}: GoogleTrackingProps) => {
  useEffect(() => {
    if (!needConsent) return;
    let ok = consent;
    if (typeof consent === 'undefined') {
      ok = ccStorage.get('cookie-consent');
    }
    const status = ok == true ? 'granted' : 'denied';

    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        analytics_storage: status,
        ad_storage: status,
        ad_user_data: status,
        ad_personalization: status,
      });
    }
  }, [consent, needConsent]);

  return (
    <>
      {gaId && <GoogleAnalytics gaId={gaId} />}
      {gtmId && <GoogleTagManager gtmId={gtmId} />}
    </>
  );
};

export default GoogleTracking;
